// frontend/src/utils/socket.js
import { io } from "socket.io-client";

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    let base = process.env.REACT_APP_API_URL;
    if (base.endsWith('/api')) base = base.slice(0, -4);
    return base;
  }
  return window.location.origin;
};

const SOCKET_URL = getApiBaseUrl();

export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  auth: {
    token: sessionStorage.getItem("token")
  },
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 12,
  reconnectionDelay: 1500,
  timeout: 20000,
  pingInterval: 25000,
  pingTimeout: 60000,
});

// Store current room so we can re-join automatically on reconnect
let currentRoomId = null;
let currentUserName = null;

export const updateSocketToken = (newToken) => {
  if (socket) {
    socket.auth.token = newToken;
    if (newToken) {
      socket.disconnect().connect();
    } else {
      socket.disconnect();
    }
  }
};

// Auto re-join room on reconnect
socket.on("reconnect", () => {
  console.log(`🔄 [Socket] Reconnected - rejoining room: ${currentRoomId}`);
  if (currentRoomId && currentUserName) {
    socket.emit("joinRoom", { roomId: currentRoomId, userName: currentUserName });
  }
});

socket.on("connect", () => {
  console.log(`✅ [Socket] Connected to ${SOCKET_URL}`);
  if (currentRoomId && currentUserName) {
    socket.emit("joinRoom", { roomId: currentRoomId, userName: currentUserName });
  }
});

socket.on("connect_error", (err) => {
  console.error("❌ [Socket] Connection error:", err.message);
});

socket.on("disconnect", (reason) => {
  console.warn(`⚠️ [Socket] Disconnected: ${reason}`);
});

export const joinRoom = (roomId, userName, callback) => {
  currentRoomId = roomId;
  currentUserName = userName;

  if (socket.connected) {
    socket.emit("joinRoom", { roomId, userName }, callback);
  } else {
    socket.once("connect", () => {
      socket.emit("joinRoom", { roomId, userName }, callback);
    });
  }
};

export default socket;